import React from 'react';
import LanguageTag from 'components/LanguageTag';
import { Tag } from 'antd';

const SurveyTitle = ({ survey }) => (survey ? (
  <>
    <LanguageTag className="margin" {...survey} />
    {survey.version && <Tag className="margin">{`v${survey.version}`}</Tag>}
    {survey.title}
  </>
) : null);

export default SurveyTitle;
